import { useCallback, useEffect, useState } from 'react';
import SUMMER_CAMPAIGN, { isCampaignActive } from '../../Data/campaignConfig';

export function useSummerCampaign() {
  const active = isCampaignActive(SUMMER_CAMPAIGN);
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    if (!active) {
      setDismissed(true);
      return;
    }
    try {
      const stored = localStorage.getItem(SUMMER_CAMPAIGN.storageKey);
      setDismissed(stored === 'true');
    } catch {
      setDismissed(false);
    }
  }, [active]);

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(SUMMER_CAMPAIGN.storageKey, 'true');
    } catch {
      /* ignore */
    }
    setDismissed(true);
  }, []);

  const shouldShowModal = active && !dismissed;

  return { campaign: SUMMER_CAMPAIGN, active, dismissed, dismiss, shouldShowModal };
}

export default useSummerCampaign;
